"use strict";

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var React = tslib_1.__importStar(require("react"));

var tooltip_1 = tslib_1.__importDefault(require("@patternfly/react-styles/css/components/Tooltip/tooltip"));

var react_styles_1 = require("@patternfly/react-styles");

exports.TooltipContent = function (_a) {
  var className = _a.className,
      children = _a.children,
      isLeftAligned = _a.isLeftAligned,
      props = tslib_1.__rest(_a, ["className", "children", "isLeftAligned"]);

  return React.createElement("div", Object.assign({
    className: react_styles_1.css(tooltip_1["default"].tooltipContent, isLeftAligned && tooltip_1["default"].modifiers.textAlignLeft, className)
  }, props), children);
};

exports.TooltipContent.displayName = 'TooltipContent';